import React from 'react';
import Sokda from '../../assests/images/skoda.png';
import ford_galaxy from '../../assests/images/galaxy.png';
import mercedes_white from '../../assests/images/mercedes_white.png';
import single_van_ftr from '../../assests/images/vito.png';
import GroupIcon from '@mui/icons-material/Group';
import DeleteIcon from '@mui/icons-material/Delete';
import Slider from "react-slick";
import { DoNotStep } from '@mui/icons-material';
import ford_bg from '../../assests/images/ford-galaxy_bg.jpg';
import vito_bg from '../../assests/images/img-ourfleet-map.png';
import meredes_bg from '../../assests/images/bg-merced.png';
import sokda_bg from '../../assests/images/skoda_bg.webp';


const PremiumVeh = () => {

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className='SamplePrevArrow-next'
                // className='Slider_top_custom_arrows-next'
                // style={{ ...style, display: "block", background: "red" }}
                onClick={onClick}
            />
        );
    }


    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className='SamplePrevArrow-prev'
                // className="Slider_top_custom_arrows"
                // style={{ ...style, display: "block", background: "green" }}
                onClick={onClick}
            />
        );
    }

    const settingsCentered = {
        dots: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "260px",
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        appendDots: dots => (
            <div
                style={{
                    backgroundColor: "transparent",
                    borderRadius: "10px",
                    padding: "10px"
                }}
            >
                <ul style={{ margin: "0px" }}> {dots} </ul>
            </div>
        ),
        customPaging: i => (
            <div
            // style={{
            //     backgroundColor: "black",
            //     width: "30px",
            //     color: "blue",
            //     border: "1px blue solid"
            // }}
            // {`${title == "home" ? "white" : "black"}`}
            ><span>
                    {i + 1}
                </span>
            </div>
        ),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: "0px",
                }
            },
        ],
    };
  
    let arr = [{
        bg_car:sokda_bg,
        image: Sokda,
        car_category: "4 Seater",
        car_name: "Sokda Superb Estate",
        fareRate: "• Fixed fare",
        payment_methode: "• Online payment method available",
        loading_capacity: "• 1 Large suitcase 3 Small Suitcases",
        tracking: "• Flight Tracking",
        service_type: "• Door-Door Service",
    }, {
        bg_car:meredes_bg,
        image: mercedes_white,
        car_category: "Executive",
        car_name: "Mercedes C Class",
        fareRate: "• Fixed fare",
        payment_methode: "• Online payment method available",
        loading_capacity: "• 1 Large suitcase 3 Small Suitcases",
        tracking: "• Flight Tracking",
        service_type: "• Door-Door Service",
    }, {
        bg_car:ford_bg,
        image: ford_galaxy,
        car_category: "6 Seater",
        car_name: "Ford Galaxy ",
        fareRate: "• Fixed fare",
        payment_methode: "• Online payment method available",
        loading_capacity: "• 4 Large suitcase & 3 Small Suitcases",
        tracking: "• Flight Tracking",
        service_type: "• Door-Door Service",
    }, {
        bg_car:vito_bg,
        image: single_van_ftr,
        car_category: "8 Seater",
        car_name: "Mercedes Vito",
        fareRate: "• Fixed fare",
        payment_methode: "• Online payment method available",
        loading_capacity: "• 8 Large suitcase & 4 Small Suitcases",
        tracking: "• Flight Tracking",
        service_type: "• Door-Door Service",
    }];

    return (
        <div>
            <div className='pb-cus'>
                {/* <div className='container pb-cus'></div> */}
                <div className='row'>
                    <div className="col-lg-12 text-center mb-4">
                        <p className="red-clr f-16 lh-1 mt-5 f-pop-med">
                            Our Fleet Slideshow
                        </p>
                        <p className="blu-clr-book f-47 lh-1 mb-2 f-pop-med">
                            Our Airport Taxis
                        </p>
                    </div>
                </div>
                <section className='slider_premium'>
                    <Slider className='slidr_premium' {...settingsCentered}>
                        {arr.map((item, i) => {
                            return (
                                <div className='pos-rel-premium' key={i}>
                                    <div className="row mx-3 my-2">
                                        <div className="col-lg-5 p-0">
                                            <div className='red_car_bg py-5 px-4'>
                                                <div>
                                                    <p className='f-18 text-white mb-3 f-pop-med'>{item.car_category}</p>
                                                    <p className='f-18 text-white mb-3 f-pop-med'>{item.car_name}</p>
                                                    <p className='f-15 text-white mb-2 f-pop-med'>{item.fareRate}</p>
                                                    <p className='f-15 text-white mb-2 f-pop-med'>{item.loading_capacity}</p>
                                                    <p className='f-15 text-white mb-2 f-pop-med'>{item.payment_methode}</p>
                                                    <p className='f-15 text-white mb-2 f-pop-med'>{item.service_type}</p>
                                                    <p className='f-15 text-white  f-pop-med'>{item.tracking}</p>
                                                    {/* <div className='row mt-4'>
                                                        <div className='col-lg-6 mt-2'>
                                                            <GroupIcon className='text-white' /> <span className='f-13 text-white f-pop-med'>4 Passengers</span>
                                                        </div>
                                                        <div className='col-lg-6 mt-2'>
                                                            <DeleteIcon className='text-white' /> <span className='f-13 text-white f-pop-med'> 2 Large Bags</span>
                                                        </div>
                                                        <div className='col-lg-6 mt-2'>
                                                            <DeleteIcon className='text-white' /> <span className='f-13 text-white f-pop-med'> 2 Small Bags</span>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div style={{ backgroundImage: `url(${item.image})` }} className='bg-mercedes_white'>

                                            </div>
                                        </div>
                                        <div className="col-lg-7 p-0">
                                        {/* linearGradient(to bottom, rgba(26, 44, 37, 0.7), rgba(26, 44, 37, 0.7)), */}
                                            <div style={{ backgroundImage:`url('${item.bg_car}')`}} className='red_car_bg_gry'>
                                        </div>
                                    </div>
                                </div>
                                </div>
                    )
                        })}
                </Slider>
            </section>
        </div>
        </div >
    )
}

export default PremiumVeh;